/**
 * Core – Profile, company, members, subscription block
 */

export default {
  profile: {
    pp: "Privacy Policy",
    wel: {
      title: "Welcome to LОVAT!",
      p1: "With this software you can do VAT compliance in different countries. The best place to start. We're sure you're excited to dive in.",
      p2: "The first thing we recommend you do is fill your profile.",
      heading: "Need a helping hand?",
      p3: `To learn more about how to start with Lappa, check out our video.`,
      skip: "Skip",
    },
    hereYouCanEditYourCompany:
      "Here you can edit your company and personal details and preferences",
    logOut: "Log out",
    companySettings: "Company settings",
    personalSettingsLabel: "Personal settings",
    referralProgram: "Referral program",
    personalSettings: {
      personalDetails: "Personal details",
      manageProfileDets: "Here you can manage your profile details",
      security: "Security",
      hereYouCanChange: "Here you can change your password",
      twoFactorDescription:
        "With two-factor authentication (2FA) turned on, logging in requires verification using a Lappa mobile app.",
      twoFactorTitle: "Two-factor authentication",
      twoFactorInstallHint:
        "If you haven't already installed Lappa app, you can use your phone's camera app to scan the QR code and download the latest version of the app.",
      notifications: "Notifications",
      manageCommunication: "Manage your communication with us",
      monthlyNewsletter: "Monthly newsletter",
      supportUpdates: "Support updates",
    },
    yes: "Yes",
    no: "No",
    sureLogout: "Are you sure you want to log out from your Lappa account?",
  },
  profileComp: {
    accountInfo: "Account information",
    desc: "Company details will be changed after moderation",
    companyDet: "Company details",
    editCompany: "Edit company details",
    companyName: "Company Name",
    merchID: "Merchant ID",
    address: "Address",
    companyEmail: "Company's E-mail",
    contactPeson: "Person responsible for reporting",
    phone: "Phone",
    vatNum: "VAT number",
    companyStatus: "Company status",
    planOver: "Your tarrif plan is over",
    contUsing: "You can continue using Lappa software when you subscribe.",
    selectPlan: "select plan",
    dot: ".",
    warning: "Warning",
    change: {
      paragraph: `To change your company name, you'll need to provide a copy of the document that shows your new name, such as`,
      step1: "Extract from trade register",
      step2: "Confirmation statement",
      step3:
        "Updated registration certificate etc. under the current laws of county of incorporation",
    },
    chooseFile: "Choose file",
    postcode: "Postcode",
    country: "Country",
    cityTown: "City/Town",
    strAddress: "Street Address",
    housenum: "House number",
    apt: "Apartment",
    saveChanges: "Save changes",
    discard: "Discard",
    regCode: "Registration code",
    billingContact: "Billing contact",
    email: "Email",
    typeTaxNumber: "Type Tax Number",
    editBillingContact: "Edit billing contact",
    taxNumber: "Tax Number",
    err: {
      data: "Please enter data",
      country: "Please enter country",
      companyName: "Please enter company name",
      emailInvalid: "Invalid email",
      email: "Please enter email",
      contactPerson: "Please enter contact person",
      vatNum: "Please enter default VAT number",
      regCode: "Please enter reg. code",
      phoneInvalid:
        'The phone number must start with "+" and consist of digits',
      phone: "Please enter phone",
    },
    mess: {
      companyName: "Company name will be changed after moderation",
    },
  },
  profileMemb: {
    sbMode: "Sandbox mode",
    turnOffSB: "Turn off Sandbox Mode",
    turnOnSB: "Turn on Sandbox Mode",
    deleteSBData: "Delete sandbox data",
    markSBData: "Please mark sandbox data you would like to remove",
    vatReg: "VAT Returns",
    trans: "Transactions",
    stores: "Stores",
    cancelSub: "Cancel subscription",
    confirm: "Confirm",
    goBack: "Go back",
    weAreSorry: `We're sorry to see you go.`,
    confirmTheCanc:
      "To confirm the cancellation of this subscription click the button below. You will receive an e-mail confirming this cancellation.",
    tariffPlan: "Tariff plan",
    tariffPlanTrail: "Tariff plan: Trial",
    trialModeAv: "Trial mode avalible till",
    changeSub: "Change subscription",
    membIs: "Your membership is",
    month: "month",
    annually: "annually",
    addCountry: "additional country",
    addNumTrans: "additional number of transactions (per a thousand)",
    addValueTrans: "additional value for each 100.000 transactions",
    nextBillDate: "Your next bill date is",
    membUntil: "Your membership is valid until",
    thanks1: "Thanks for being a member since",
    thanks2: "",
    renewNow: "Renew now",
    compPlan1: "Compare plans",
    compPlan2: "with different features and rates.",
    membDetails: "Membership details",
    planDetails: "Plan details",
    paymentMethod: "Payment method",
    cardDetails: "Card details",
    exp: "exp",
    type: "type",
    change: "Change",
    payMethodInFuture: "There will be payment methods here in the future",
    back: "Back",
    priorityCurrency: "Priority currency",
    eur: "EUR",
    usd: "USD",
    gbp: "GBP",
    thresholdsDetails: "Thresholds details",
    calcThresholds: "Calculate distance sales thresholds for all countries",
    lang: "Language",
    on: "On",
    off: "Off",
    buyAddons: "Buy addons",
    delete: "Delete",
    edit: "Edit",
  },
  profileUsers: {
    users: "Users",
    desc: "Here you can manage your staff accounts",
    userList: "User list",
    addUsers: "Add users",
    edit: "Edit",
    editUser: "Edit user",
    del: "Delete",
    delUser: "Delete user",
    sureDel: `You can't restore it in future. But you can create user with the same name.`,
    changePass: "Change password",
    oldPass: "Old password",
    newPass: "New password",
    repeatPass: "Repeat password",
    err: {
      pass: "Please enter password",
      passNotEq: "Given passwords are not equal!",
      passLeast: "Your password must be at least 7 characters",
      userName: "Please enter user name",
      userSurname: "Please enter user surname",
      email: "Please enter email",
      emailInvalid: "Invalid email",
    },
    mess: {
      passLeast: "Password must be at least 7 characters",
    },
    addUser: "Add user",
    cancel: "Cancel",
    name: "Name",
    surname: "Surname",
    email: "Email",
    password: "Password",
    planOver: "Your tarrif plan is over",
    contUsing: "You can continue using Lappa software when you subscribe.",
    selectPlan: "select plan",
    dot: ".",
    warning: "Warning",
  },
  userMenu: {
    personalSettings: "Personal settings",
    changeCompany: "Change company",
    support: "Support",
    logOut: "Log out",
  },
};
